// The list says "online" for a window after the last heartbeat, and no push comes when the relay could
// not see the socket close (its restart, another instance). So a row past a missed beat is read again.
export const DAEMON_LIST_ONLINE_WINDOW_MS = 60_000;
const MISSED_HEARTBEAT_MS = 35_000;
const PAST_THE_WINDOW_MS = 1_000;

export function daemonGraceRecheckMs(
  daemons: ReadonlyArray<{ status: string; lastSeenAt?: number | null }>,
  now: number,
): number | undefined {
  let soonest: number | undefined;
  for (const d of daemons) {
    if (d.status !== "online" || typeof d.lastSeenAt !== "number") continue;
    const age = now - d.lastSeenAt;
    if (age <= MISSED_HEARTBEAT_MS || age >= DAEMON_LIST_ONLINE_WINDOW_MS) continue;
    const due = DAEMON_LIST_ONLINE_WINDOW_MS - age + PAST_THE_WINDOW_MS;
    if (soonest === undefined || due < soonest) soonest = due;
  }
  return soonest;
}
